import { EVENTS } from '@/lib/consts.ts'

export const gtm1TrialClaim = {
  [EVENTS.TRIAL_CLAIM_ACTION] ({ data }) {
    return {
      event: 'Trial_Claim_Action',
      properties: {
        screen_name: data.screenName,
        event_action: data.eventAction,
      },
    }
  },
}
